import { FC, useContext } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { Button } from '../../../common/components/Button'
import { ChatContext } from '../../context/ChatContext'
import { ChatBoxContext } from '../ChatBoxContext'
import { ChatBoxSendMessageFactory } from '../form/ChatBoxSendMessageFactory'
import { LoadingSpinner } from '../../../common/components/LoadingSpinner'
import { ModalDialogTitle } from '../../../common/components/ModalDialog'

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'stretch',
  gap: 8,
  padding: 20,
  paddingTop: 12,
})

export const ChatBoxFileConfirmationBody: FC<{ file: File }> = ({ file }) => {
  const { t } = useTranslation()
  const { form, websocket } = useContext(ChatContext)
  const { formEnabled, confirmSending } = useContext(ChatBoxContext)

  return (
    <Container>
      <ModalDialogTitle>
        {formEnabled ? t('The file is ready to be sent') : t('Wait a moment, the chat is not ready yet')}
      </ModalDialogTitle>

      <Button
        primary
        big
        disabled={!formEnabled}
        onClick={async () => {
          const messageFile = await ChatBoxSendMessageFactory.getMessageFile(file)

          if (messageFile) {
            form.reset()

            await websocket.sendMessage({
              text: null,
              file: messageFile,
            })

            confirmSending()
          }
        }}
      >
        {formEnabled ? t('Send') : <LoadingSpinner />}
      </Button>

      <Button
        big
        onClick={() => {
          form.resetField('files')
        }}
      >
        {t('Cancel')}
      </Button>
    </Container>
  )
}
